import success_tick from "../../../assets/images/status/successful_tick_150x150.png";
import ModalAlert from "../../../components/core/basic/ModalAlert";
import { useTranslation } from "react-i18next";
import { useNavigate } from "@tanstack/react-router";
import { refreshAmzOnboardStatus, updateAmzOnboardingStatus } from "../../../redux/reducers/amzOnboardReducer";
import { setErrors } from "../../../redux/reducers/errorReducers";
import { useAppDispatch } from "../../../redux/hooks";
import { css } from "../../../../styled-system/css";

export function PaymentProcessing({ subSuccessful, discoveryType }) {
  const { t } = useTranslation(["admin"]);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleClick = () => {
    refreshAmzOnboardStatus(
      (status) => dispatch(updateAmzOnboardingStatus(status)),
      (err) => dispatch(setErrors(err)),
    );

    discoveryType === "pricing" ?
      navigate({ to: "/user/pricing/dashboard", state: { firstVisit: true } })
    : navigate({ to: "/user/dashboard" });

    refreshAmzOnboardStatus(
      (status) => dispatch(updateAmzOnboardingStatus(status)),
      (err) => dispatch(setErrors(err)),
    );
  };

  return (
    <ModalAlert
      title={
        subSuccessful ? t(($) => $.admin["Subscription Successful"]) : t(($) => $.admin["Processing Subscription"])
      }
      onClick={handleClick}
      msg={
        !subSuccessful ?
          <>
            <p className={css({ paddingBottom: "large" })}>{t(($) => $.admin["Please Wait..."])}</p>
            <p>
              {t(
                ($) =>
                  $.admin[
                    "We're processing your transaction. Please don't reload or refresh the page, this may take a few seconds."
                  ],
              )}
            </p>
          </>
        : <>
            <p className={css({ paddingBottom: "large" })}>{t(($) => $.admin["Subscription Completed!"])}</p>
            <img
              height="75px"
              width="75px"
              src={success_tick}
              alt={t(($) => $.admin["Connected Advertising Account"])}
              className="text-center"
            />
            <p className={css({ paddingTop: "large" })}>
              {t(($) => $.admin["A confirmation email has been sent to you."])}
            </p>
          </>
      }
      disableConfirmButton={!subSuccessful}
      inline
    />
  );
}
